// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"20ae72e4","774":"38fe79c3","787":"5f005e52","845":"1e86813b"}[chunkId] + ".chunk.js";
};